import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    REQUEST_LIST_ALERT_CONFIGS,
    REQUEST_ADD_ALERT_CONFIG_HEADER,
    REQUEST_UPDATE_ALERT_CONFIG,
    REQUEST_REMOVE_ALERT_CONFIG,
    REQUEST_ACTIVATE_ALERT,
    REQUEST_DEACTIVATE_ALERT,
    REQUEST_UPDATE_AND_ACTIVATE_ALERT,
    REQUEST_LIST_ALERT_SCHED_CONFIGS,
    REQUEST_CREATE_ALERT_SCHED,
    REQUEST_UPDATE_ALERT_SCHED,
    REQUEST_REMOVE_ALERT_SCHED,
    REQUEST_ACTIVATE_ALERT_SCHED,
    REQUEST_DEACTIVATE_ALERT_SCHED,
} from "./messageTypes";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { AlertConfigHeader, AlertConfig } from "../models/alertInterfaces";
import { AlertSchedConfig } from "userful-chronos-app-common-js/dist/models/alert/alertInterfaces";

export const requestListAlertConfigs = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_ALERT_CONFIGS);
};

export const requestAddAlertConfigHeader = (header: AlertConfigHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_ALERT_CONFIG_HEADER, header);
};

export const requestUpdateAlertConfig = (alertConfig: AlertConfig) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_ALERT_CONFIG, alertConfig);
};

export const requestRemoveAlertConfig = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_ALERT_CONFIG, id);
};

export const requestActivateAlert = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ACTIVATE_ALERT, id);
};

export const requestDeactivateAlert = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_DEACTIVATE_ALERT, id);
};

export const requestUpdateAndActivateAlert = (alertConfig: AlertConfig) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_AND_ACTIVATE_ALERT, alertConfig);
};

export const requestListAlertConfigsSched = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_ALERT_SCHED_CONFIGS);
};

export const requestAddAlertConfigSched = (header: AlertSchedConfig) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_CREATE_ALERT_SCHED, header);
};

export const requestUpdateAlertConfigSched = (alertConfig: AlertSchedConfig) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_ALERT_SCHED, alertConfig);
};

export const requestRemoveAlertConfigSched = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_ALERT_SCHED, id);
};

export const requestActivateAlertSched = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ACTIVATE_ALERT_SCHED, id);
};

export const requestDeactivateAlertSched = (id: StringID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_DEACTIVATE_ALERT_SCHED, id);
};
